import React from 'react';

const VideoPlayer = ({ videoUrl }) => {
  // Extract video ID from YouTube URL
  const getYouTubeId = (url) => {
    if (!url) return null;
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  const videoId = getYouTubeId(videoUrl);

  if (!videoUrl) {
    return (
      <div 
        className="w-full h-64 md:h-96 bg-gray-200 rounded-lg flex items-center justify-center border-2 border-dashed border-gray-400"
        data-testid="video-placeholder"
      >
        <div className="text-center">
          <svg className="w-16 h-16 mx-auto mb-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" />
          </svg>
          <p className="text-gray-500 font-medium">Video Placeholder</p>
          <p className="text-sm text-gray-400 mt-1">YouTube video will appear here</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full aspect-video rounded-lg overflow-hidden shadow-lg">
      <iframe
        width="100%"
        height="100%"
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        data-testid="youtube-video"
      ></iframe>
    </div>
  );
};

export default VideoPlayer;